import { CkBTCMinterCanister } from '@dfinity/ckbtc'
import { CKBTC_MINTER_CANISTER_ID } from '../constants/canisterIds'
import { Principal } from '@dfinity/principal'
import getAgent from './getAgent'

export const getBtcMinterAddress = (owner: Principal) => {
  const minter = CkBTCMinterCanister.create({
    agent: getAgent(),
    canisterId: Principal.from(CKBTC_MINTER_CANISTER_ID),
  })

  return minter.getBtcAddress({ owner })
}
